import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { IBillerShort } from '../models/model';

@Injectable({
  providedIn: 'root',
})
export class BillerService {
  constructor(private api: ApiService) {}

  public addBiller(billerDisplayName: string): Observable<string> {
    return this.api.post<string>('/billers', { billerDisplayName });
  }

  public getBillerCategories(customerBillerId: string): Observable<string[]> {
    return this.api.get<string[]>(`/billers/customer-billers/${customerBillerId}/categories`);
  }

  public getBillers(search: string): Observable<IBillerShort[]> {
    return this.api.get<IBillerShort[]>(`/billers/search/${search}`);
  }

}
